module.exports = __webpack_public_path__ + "img/shogi_2021_pack_1_0003.ae302dc8.png";